export default __webpack_public_path__ + "static/media/instagram-logo.b1c90ba7.svg";